<div class="bg-lightGrayish flex w-full max-w-[80rem] flex-col gap-4 p-6 lg:h-64 lg:gap-5">
  <app-text-content-box [headline]="'Revenue Targets'" [headerIcon]="'📈'" class="lg:pb-2"></app-text-content-box>
  <div class="mr-[0.6rem] lg:mr-[1.2rem]">
    <div class="relative">
      <div
        [ngStyle]="{ 'width': progressPercentage + '%', 'max-width': '100%' }"
        [title]="'Real: ' + helperService.sumToFixed(quarters[3].realSum, 'progressBar')"
        class="absolute z-10 h-6 border-r bg-[#FAEED7]"
      ></div>
      <div
        [title]="'Goal: ' + helperService.sumToFixed(quarters[3].goalSum, 'progressBar')"
        class="h-6 w-full bg-white"
      ></div>
    </div>
  </div>
  <div class="z-20 flex w-full pl-4 text-[10px] font-semibold lg:text-lg">
    @for (quarter of quarters; track quarter) {
      <div class="text-veryFaintBlack flex w-full justify-center">{{ quarter.label }}</div>
      <div class="flex flex-col items-center">
        <div class="-mt-11 h-12 w-1/2 border-r-2 border-r-black"></div>
        <p>{{ helperService.sumToFixed(quarter.realSum, 'progressBar') }}</p>
        <p class="text-veryFaintBlack">{{ helperService.sumToFixed(quarter.goalSum, 'progressBar') }}</p>
      </div>
    }
  </div>
</div>
